module.exports = __webpack_public_path__ + "img/16_101.edb25aa9.png";